@if (isEnabled()) {
    <vn-recaptcha-enterprise [(ngModel)]="model" (success)="onResolved($event)" [action]="area" />
}
